<fa-icon [icon]="faArrowDown" *ngIf="currentSortBy == wantedSortBy && orderAsc"></fa-icon>
<fa-icon [icon]="faArrowUp" *ngIf="currentSortBy == wantedSortBy && !orderAsc"></fa-icon>
